import { IColumn } from '@fluentui/react';

export type ColumnData = IColumn & {
  /** property to determine whether this coloumn can be toggled for visibility */
  toggleVisibility?: boolean;
  /** property to determine whether the column is visble or not*/
  isVisible?: boolean;
  isFormField?: boolean;
  viewWidth?: number;
  isTransactionOnly?: boolean;
};

const columns = new Map<string, ColumnData>([
  [
    '_fullComment',
    {
      key: '_fullComment',
      name: 'Description',
      fieldName: '_fullComment',
      minWidth: 300,
      maxWidth: 500,
      viewWidth: 100,
      isVisible: true,
    },
  ],
  [
    'testDate',
    {
      key: 'testDate',
      name: 'Run date',
      fieldName: 'testDate',
      minWidth: 300,
      maxWidth: 500,
      viewWidth: 100,
      isVisible: true,
    },
  ],
  [
    'isGlobalTest',
    {
      key: 'isGlobalTest',
      name: 'Global test',
      fieldName: 'isGlobalTest',
      minWidth: 100,
      maxWidth: 100,
      viewWidth: 100,
      isVisible: true,
    },
  ],
  [
    'statusType',
    {
      key: 'statusType',
      name: 'Status',
      fieldName: 'statusType',
      minWidth: 100,
      maxWidth: 100,
      viewWidth: 100,
      isVisible: true,
    },
  ],
]);

export const getColumns = (profileData?: any | undefined) => {
  const columnArray = Array.from(columns, (data) => data[1]);
  return { columnArray };
};
